// extracted by mini-css-extract-plugin
export default {"formWrapper":"style_formWrapper__3ytkd","formItemLabel":"style_formItemLabel__fGGq4","btnSignin":"style_btnSignin__gdVH4"};